import Installment from "./Installment";
import LineOfCredit from "./LineOfCredit";
import Mortgage from "./Mortgage";
import Open from "./Open";
import Revolving from "./Revolving";

type TradeProps = {
  sourcedata: any;
};

const Trade = ({ sourcedata }: TradeProps) => (
  <>
    {sourcedata?.tradeData?.installment &&
      sourcedata?.tradeData?.installment.length > 0 && (
        <Installment sourcedata={sourcedata} />
      )}
    {sourcedata?.tradeData?.revolving &&
      sourcedata?.tradeData?.revolving.length > 0 && (
        <Revolving sourcedata={sourcedata} />
      )}
    {sourcedata?.tradeData?.lineOfCredit &&
      sourcedata?.tradeData?.lineOfCredit.length > 0 && (
        <LineOfCredit sourcedata={sourcedata} />
      )}
    {sourcedata?.tradeData?.open && sourcedata?.tradeData?.open.length > 0 && (
      <Open sourcedata={sourcedata} />
    )}
    {sourcedata?.tradeData?.mortgage &&
      sourcedata?.tradeData?.mortgage.length > 0 && (
        <Mortgage sourcedata={sourcedata} />
      )}
  </>
);

export default Trade;
